export default class JWTTokenExpireError extends Error {
    constructor(message) {
        super(message);

        this.name = 'JWTTokenExpireError';
    }
}


// WEBPACK FOOTER //
// ./src/helpers/errors/JWTTokenExpireError.js